import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowMove16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowMove16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.526 4.354a.5.5 0 0 1 0-.707l2.121-2.122.354-.353.353.353 2.122 2.122a.5.5 0 1 1-.707.707L8.5 3.086V7.5h4.415l-1.268-1.267a.5.5 0 1 1 .707-.707l2.122 2.12.353.354-.353.354-2.122 2.121a.5.5 0 0 1-.707-.707L12.915 8.5H8.5v4.415l1.268-1.268a.5.5 0 1 1 .707.707l-2.12 2.121L8 14.83l-.354-.354-2.121-2.12a.5.5 0 1 1 .707-.708L7.5 12.915V8.5H3.086l1.267 1.268a.5.5 0 0 1-.707.707L1.525 8.354 1.17 8l.354-.353 2.121-2.122a.5.5 0 0 1 .707.708L3.086 7.5H7.5V3.086L6.233 4.354a.5.5 0 0 1-.707 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowMove16);
